
<template>
  <div>
    <div :style="fromParams.outSideStyle">
      <div v-for="(item, index) in fromParams.mainSearchList" :key="index">
        <div v-if="item.type === 'cascader'" :style="{
            margin: item.margin ? item.margin : '',
            width: item.divWidth ? item.divWidth : '250px',
            display: 'flex','align-items': 'center','justify-content': 'space-between',
          }">
          <span :style="{ width: item.spanWidth ? item.spanWidth : '80px' }">
            <span style="color:red;" v-if="item.require">*</span>
            {{
            item.spanName
          }}</span>
          <el-cascader clearable :placeholder="
              item.placeholder ? item.placeholder : `请选择${item.Name}`
            " v-model="addObject[item.modelObj.value]" :size="item.size ? item.size : ''" :options="item.options()" :props="item.props" @change="item.event.change($event, item.needAutoQuery)">
            <!-- cascader没有clear事件 -->
          </el-cascader>
        </div>
        <div v-if="item.type === 'select'" :style="{
            width: item.divWidth ? item.divWidth : '250px',
            display:item.display?item.display:'flex',
            'align-items': 'center',
            'justify-content': 'space-between',
            margin: item.divMargin ? item.divMargin : '',
          }">
          <span :style="{ width: item.spanWidth ? item.spanWidth : '80px' }">
            <span style="color:red;" v-if="item.require">*</span>
            {{
            item.spanName
          }}</span>
          <el-select :filterable="fromParams.call(item.event.filter)
                ? true
                : false" :filter-method="fromParams.call(item.event.filter)
                ? item.event.filter
                : null" @focus="fromParams.call(item.event.focus)
                ? item.event.focus()
                : null" :style="{ margin: item.margin, width: item.inputWidth }" size="mini" :multiple="item.multiple" :placeholder="item.placeholder? item.placeholde:'请选择'" @clear="
              fromParams.call(item.event.clear)
                ? item.event.clear($event)
                : null
            " :clearable="item.clearable? false : true" v-model="addObject[item.modelObj.value]" @change="item.event.changeProduct($event, item.needAutoQuery)">
            <el-option v-for="option in item.list()" :key="option[item.selectValue ? item.selectValue : 'value']" :label="option[item.selectLabel ? item.selectLabel : 'label']" :value="option[item.selectValue ? item.selectValue : 'value']"></el-option>
          </el-select>
        </div>
        <div v-if="item.type === 'empty'">
          <div :style="{
              width: item.Width ? item.Width : '250px',
              margin: item.margin ? item.margin : '',
            }"></div>
        </div>
        <div v-if="item.type === 'input'">
          <el-input :style="{
              width: item.inputWidth,
              margin: item.margin ? item.margin : '',
            }" :disabled="item.disabled" clearable v-model="addObject[item.modelObj.value]" :size="item.size ? item.size : ''" :placeholder="
              item.placeholder ? item.placeholder : `请输入${item.Name}`
            ">
            <template slot="prepend">
              <span style="color:red;" v-if="item.require">*</span> {{ item.Name }}</template>
          </el-input>
        </div>
        <div v-if="item.type === 'date-picke'" :style="{
            width: item.divWidth ? item.divWidth : '250px',
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'space-between',
          }">
          <span :style="{ width: item.spanWidth ? item.spanWidth : '80px' }">
            <span style="color:red;" v-if="item.require">*</span>
            {{
            item.name
          }}</span>
          <el-date-picker :type="item.isDatetime ? item.isDatetime : 'date'" :picker-options="item.pickerSetTime ? $data['pickerSetTime'] : ''" :style="{
              margin: item.margin ? item.margin : '',
              width: item.inputWidth,
            }" @clear="
              fromParams.call(item.event.clear)
                ? item.event.clear($event)
                : null
            " :clearable="item.clearable? false : true" @change="
              fromParams.call(item.event.change)
                ? item.event.change($event)
                : null
            " :size="item.size ? item.size : ''" v-model="addObject[item.modelObj.value]" align="right" :value-format="item.valueFormat" :placeholder="
              item.placeholder ? item.placeholder : `请输入${item.name}`
            "></el-date-picker>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  props: {
    fromParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    requestParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    addObject: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },


  components: {},
  data () {
    //这里存放数据
    return {
      pickerSetTime: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    test () {
      console.log(3232)
    },
    openAddDialog () {
      this.$emit("openAddDialog");
    },
    getList (item) {
      this.$emit("getList", item);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created () {
    // console.log(this);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted () { },
};
</script>



// WEBPACK FOOTER //
// src/components/QuotationManagement/jack-components/erp-copy/erp-form.vue